export default "__VITE_ASSET__DGBVXvNT__"